import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import styled from "@emotion/styled";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import { APPNAME } from "../components/Constants";
import { withStyles } from "@material-ui/core/styles";
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDownOutlined";
import ArrowUpIcon from "@material-ui/icons/KeyboardArrowUpOutlined";
import MoreIcon from "@material-ui/icons/MoreVertOutlined";
import LogoutIcon from "@material-ui/icons/ExitToAppOutlined";
import BackIcon from "@material-ui/icons/SettingsBackupRestoreOutlined";
import ExceptionsPage from "../containers/ExceptionsPage";
import ConfirmDialog from "../components/ConfirmDialog";

import { withTranslation } from "react-i18next";
import { Divider } from "@material-ui/core";

import RevalidateIcon from "@material-ui/icons/RefreshOutlined";
import ReturnIcon from "@material-ui/icons/CloseOutlined";
import PayIcon from "@material-ui/icons/CheckOutlined";

const styles = (theme) => ({
  header: {
    fontWeight: "normal",
    fontFamily: "Roboto-regular",
    fontSize: "16pt",
  },
  primaryText: {
    fontWeight: "normal",
    fontFamily: "Roboto-regular",
    fontSize: "12pt",
  },
  secondaryText: {
    fontWeight: "normal",
    fontFamily: "Roboto-regular",
    fontSize: "12pt",
    color: "#7c7c7c",
  },
  bodyFont: {
    fontWeight: "normal",
    fontFamily: "Roboto-regular",
    fontSize: "12pt",
  },
  bottom: {
    bottom: 0,
    position: "fixed",
    width: "99%",
    padding: 0,
  },
  input: {
    backgroundColor: "primary",
    background: "hidden",
  },
  dropdown: {
    position: "relative",
    display: "inline-block",
    bottom: 0,
  },
  dropdownContent: {
    display: "block",
    position: "absolute",
    backgroundColor: "#f0f0f0",
    minWidth: 90,
    right: 36,
    top: -10,
  },
  line: {
    backgroundColor: "#e8e8e8",
    color: "#fff",
    padding: 1,
    border: "none",
    textDecoration: "none",
    width: 98,
  },
});

const StyledHtmlSelect = styled.select`
  padding: 0;
  margin: 0 0 0 10px;
  height: 23px !important;
  color: #fff;
  background: #2196f3;
`;

class InfoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      notifyOnlyString: "",
      validationError: "",
      actionError: "",
      userName: "",
      companyName: "",
      lastLogin: "",
      sessionTime: "",
      messagesShowing: false,
      messages: [],
      logoFile: "",
      secureToken: "",
      blockShowing: false,
      minutesLeft: 0,
      accountsWithEX: [],
      selectedItemObject: {},
      selectedAccountIndex: 0,
      openId: 0,
      exceptionType: 0,
      detailedItem: {},
      checkNumber: "",
      amount: "",
      payee: "",
      iPayee: "",
      returnCode: "000",
      returnedReason: "",
      comment: "",
      authCode: "",
      status: "",
      transit: "",
      account: "",
      returnCodes: [],
      uiExclusionsList: [],
      showReasons: false,
      selectedReason: 0,
      viewCheckDetail: false,
      item: {},
      compName: "",
      type: 1,
      achItemDetails: [],
      selectedAchItemObject: {},
      selectedAchItemIndex: 0,
      detailShowing: false,
      openAchId: 0,
      selectedAchObject: {},
      selectedAchIndex: 0,
      menuShowing: false,
      openMenuId: 0,
      selectedNoteObject: {},
      selectedNoteIndex: 0,
      newNote: "",
      noteChanged: false,
      statusChanged: false,
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubpageCallback = this.handleSubpageCallback.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseNotifyOnly = this.onCloseNotifyOnly.bind(this);
    this.handleSaveAch = this.handleSaveAch.bind(this);
  }

  handleLogout(e) {
    e.preventDefault();
    fetch("on_logout", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        if (window.sco_return_url) {
          window.location.href = window.sco_return_url;
        } else {
          this.props.history.push("/");
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleSelectAccount(e, index, item) {
    this.setState({ selectedAccountIndex: index });
    this.setState({ selectedItemObject: item });
    this.setState({ type: 1 });
    let current = this.state.openId;
    if (current === index) {
      let showBlock = this.state.blockShowing;
      showBlock = !showBlock;
      this.setState({ blockShowing: showBlock });
    } else {
      this.setState({ blockShowing: true });
      this.setState({ openId: index });
    }
  }

  handleSelectAchItem(e, index, item) {
    this.setState({ selectedAchItemIndex: index });
    this.setState({ selectedAchItemObject: item });

    this.setState({ selectedAchIndex: 0 });
    this.setState({ menuShowing: false });
    this.setState({ openMenuId: 0 });

    let current = this.state.openAchId;
    if (current === index) {
      let showBlock = this.state.detailShowing;
      showBlock = !showBlock;
      this.setState({ detailShowing: showBlock });
    } else {
      this.setState({ detailShowing: true });
      this.setState({ openAchId: index });
    }
  }

  handleSelectAch(e, index, item) {
    this.setState({ selectedAchIndex: index });
    this.setState({ selectedAchObject: item });

    let current = this.state.openMenuId;
    if (current === index) {
      let showBlock = this.state.menuShowing;
      showBlock = !showBlock;
      this.setState({ menuShowing: showBlock });
    } else {
      this.setState({ menuShowing: true });
      this.setState({ openMenuId: index });
      document.getElementById("idach" + index).scrollIntoView();
    }
  }

  handleSelectAddNote(e, index, item) {
    this.setState({ selectedNoteIndex: index });
    this.setState({ selectedNoteObject: item });
    this.setState({ exceptionType: 3 });
  }

  handleChangeStatus(e, index, item, action) {
    let achItemDetails = this.state.achItemDetails;
    if (item.status === action) {
      this.setState({
        notifyOnlyString: "The status of this item keeps no change.",
      });
      this.setState({ viewPopup: true });
    } else {
      achItemDetails[index - 1].status = action;
      this.setState({
        notifyOnlyString: "The status of this item has been changed.",
      });
      this.setState({ viewPopup: true });
      this.setState({ achItemDetails: achItemDetails });
      this.setState({ statusChanged: true });
    }
  }

  handleShowImg() {
    this.setState({ exceptionType: 4 });
  }

  handleClose() {
    this.setState({ selectedAchIndex: 0 });
    this.setState({ menuShowing: false });
    this.setState({ openMenuId: 0 });
  }

  componentDidMount() {
    let { t } = this.props;
    if (this.props.errorString.length > 0) {
      this.setState({ errorString: this.props.errorString });
    } else {
      var reply = this.props.reply;
      if (reply.authenticated === false) {
        this.props.history.push("/expired");
      } else {
        this.setState({ userName: reply.userName });
        this.setState({ companyName: reply.companyName });
        this.setState({ lastLogin: reply.lastLogin });
        this.setState({
          sessionTime:
            t("after.label") + reply.sessionTime + t("minutesInactivity.label"),
        });
        this.setState({ logoFile: reply.logoFileName });
        this.setState({ bankRealm: reply.bankRealm });
        this.setState({ secureToken: reply.secureToken });
        this.setState({ uiExclusionsList: reply.ui_exclusions });
        if (reply.numMessages > 0) this.setState({ messagesShowing: true });
        this.setState({ messages: reply.messages });
        this.setState({ minutesLeft: reply.minutesLeft });
        this.setState({ accountsWithEX: reply.accountsWithEX });
        if (reply.error) {
          this.setState({ errorString: reply.errorString });
        }
      }
    }
  }

  handleSubpageCallback(action, item, transit, account, secureToken, paras) {
    this.setState({ exceptionType: action });
    this.setState({ item: item });
    window.scrollTo(0, 0); // move to the top of page
    if (action === 1) {
      // check exception details
      this.setState({ returnCodes: paras });
      this.setState({ checkNumber: item.checkNumber });
      this.setState({ amount: item.amount });
      this.setState({ status: item.status });
      this.setState({ payee: item.payee });
      this.setState({ reason: item.reason });
      this.setState({ trace: item.trace });
      this.setState({ currentDay: item.currentDay });
      this.setState({ viewCheckDetail: false });
      fetch("on_get_exception_detail", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          r: new Date().getTime(),
          secureToken: secureToken,
          transit: transit,
          account: account,
          item: item,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (reply.authenticated === false) {
            this.props.history.push("/expired");
          } else {
            if (reply.error) this.setState({ errorString: reply.errorString });
            else {
              this.setState({ detailedItem: reply.item });
              let detItem = reply.item;

              //this.setState({type: detItem.validType})
              this.setState({ issueAmount: detItem.issueAmount });
              this.setState({ comment: detItem.notes });
              this.setState({ authCode: detItem.ecc });
              this.setState({ returnCode: detItem.retCode });
              this.setState({
                returnedReason: this.getReason(detItem.retCode),
              });
              this.setState({ iPayee: detItem.ipayee });
              this.setState({ transit: transit });
              this.setState({ account: account });
              this.setState({ viewCheckDetail: true });
            }
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
    } else {
      this.setState({ compName: item.companyName });
      this.setState({ achItemDetails: paras });
      this.setState({ openAchId: 0 });
      this.setState({ detailShowing: false });
    }
  }

  handleCheckNumber(e) {
    this.setState({ checkNumber: e.target.value });
  }

  handleAmount(e) {
    this.setState({ amount: e.target.value });
  }

  handlePayee(e) {
    this.setState({ payee: e.target.value });
  }
  handleAuthCode(e) {
    this.setState({ authCode: e.target.value });
  }
  handleNewNote(e, oldNote, status) {
    if (status !== "Unreviewed" && status !== "Deferred") {
      this.setState({ newNote: e.target.value });
      this.setState({ noteChanged: true });
    } else {
      this.setState({ newNote: oldNote });
    }
  }
  onClose(e) {
    e.preventDefault();
    this.setState({ errorString: "" });
    this.setState({ validationError: "" });
    this.setState({ actionError: "" });
    this.setState({ viewPopup: false });
  }
  onClosePopup(e) {
    this.setState({ notifyString: "" });
    this.setState({ viewPopup: false });
    fetch("on_get_exceptionsData", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.state.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        this.setState({ minutesLeft: reply.minutesLeft });
        this.setState({ accountsWithEX: reply.accountsWithEX });
      })
      .catch((error) => {
        this.setState({
          errorString: "The server responded with a status of " + error.message,
        });
        this.setState({ viewPopup: true });
      });

    this.setState({ exceptionType: 0 });
  }
  onCloseNotifyOnly(e) {
    this.setState({ notifyOnlyString: "" });
    this.setState({ viewPopup: false });
  }
  handleReturnCode(e) {
    this.setState({ returnCode: e.target.value });
    this.disposition(false, e.target.value);
  }
  onPay(e) {
    if (!this.validateInput(this.state.detailedItem.eccRequired)) {
      return;
    }
    this.disposition(true, "");
  }
  onRevalidate(e) {
    if (!this.validateInput(this.state.detailedItem.eccRequired)) {
      return;
    }
    if (this.state.status === "Pay") {
      this.setState({
        validationError:
          "This item cannot be revalidated since already paid. Please select to return or pay this item.",
      });
      this.setState({ viewPopup: true });
      return;
    }
    fetch("on_revalidate_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.state.transit,
        account: this.state.account,
        pay: true,
        checkNumber: this.state.checkNumber,
        amount: this.state.amount,
        payee: this.state.payee,
        ecc: this.state.authCode,
        returnReason: this.state.returnCode,
        comment: this.state.comment,
        item: this.state.item,
        secureToken: this.state.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ dispositioned: true });
          if (reply.pay) {
            this.setState({
              notifyString: "Revalidate successfully.This item has been paid.",
            });
            this.setState({ viewPopup: true });
          } else
            this.setState({
              validationError:
                "Revalidate failed. The reason is " +
                reply.reasonRejected +
                ".",
            });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }
  validateInput(authCodeRequired) {
    if (this.state.checkNumber.length === 0) {
      this.setState({
        validationError: getErrorString(
          "stopPayment.checkNumber.error",
          "Check Number is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    if (this.state.amount.length === 0) {
      this.setState({
        validationError: getErrorString(
          "stopPayment.amount.error",
          "Amount is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    if (this.state.payee.length === 0) {
      this.setState({
        validationError: getErrorString(
          "disposition.payee.error",
          "Payee is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    if (authCodeRequired && this.state.authCode.length === 0) {
      this.setState({
        validationError: getErrorString(
          "revalidation.authCode.error",
          "Authentication Code is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  disposition(actionPay, returnCode) {
    fetch("on_disposition_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.state.transit,
        account: this.state.account,
        pay: actionPay,
        checkNumber: this.state.checkNumber,
        amount: this.state.amount,
        payee: this.state.payee,
        ecc: this.state.authCode,
        returnReason: returnCode,
        comment: this.state.comment,
        item: this.state.item,
        secureToken: this.state.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (actionPay)
            this.setState({ notifyString: "This item has been paid." });
          else this.setState({ notifyString: "This item has been returned." });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleBack(e, type) {
    if (type === 2) {
      this.setState({ exceptionType: 1 });
    } else {
      this.setState({ exceptionType: 0 });
      this.setState({ type: type });
      if (type === 0) {
        // save Ach exception modifications including status and notes
        if (this.state.statusChanged || this.state.noteChanged) {
          this.handleSaveAch(e, 3);
        } else {
          this.setState({ notifyOnlyString: "No data modified." });
          this.setState({ viewPopup: true });
        }
      }
    }
  }

  handleSaveAch(event, action) {
    // action = 1 - confirmed
    if (action === 1) {
      this.setState({ confirmSaveDialog: false });
      this.setState({ blockShowing: false });
      fetch("on_save_ach_exceptions", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          details: this.state.achItemDetails,
          secureToken: this.state.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.setState({
              notifyString: "The ACH Exception data have been modified.",
            });
            this.setState({ viewPopup: true });
            this.setState({ statusChanged: false });
            this.setState({ noteChanged: false });
            this.setState({ blockShowing: true });
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
    // action = 2 - cancelled
    else if (action === 2) {
      this.setState({ confirmSaveDialog: false });
      this.setState({ statusChanged: false });
      this.setState({ noteChanged: false });
    }
    // action = 3 - open dialog
    else if (action === 3) {
      this.setState({ confirmSaveDialog: true });
    }
  }

  handleSetNewNote(e) {
    let achItemDetails = this.state.achItemDetails;
    let selectItemIndex = this.state.selectedNoteIndex;
    achItemDetails[selectItemIndex - 1].note = this.state.newNote;
    this.setState({ achItemDetails: achItemDetails });
    this.setState({ exceptionType: 2 });
    this.setState({ selectedAchIndex: 0 });
    this.setState({ menuShowing: false });
    this.setState({ openMenuId: 0 });
    this.setState({ selectedAchItemIndex: 0 });
    this.setState({ detailShowing: false });
    this.setState({ openAchId: 0 });
  }

  getReason(retcode) {
    let reasons = this.state.returnCodes;
    let i;
    for (i = 0; i < reasons.length; i++) {
      if (reasons[i].id === retcode) {
        return reasons[i].description;
      }
    }
  }

  isSelected = (id) => this.state.selectedReason === id;
  render() {
    let messages = this.state.messages;
    let items = this.state.accountsWithEX;
    let { t } = this.props;
    const { classes } = this.props;
    let imgUrl = "img/src" + new Date().getTime() + ".png";
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            {this.state.logoFile.length === 0 && (
              <Typography variant="title" color="inherit">
                {APPNAME}
              </Typography>
            )}
            {this.state.logoFile.length > 0 && (
              <img
                src={"logo/logo_" + this.state.imageFile}
                alt="Not Available"
                style={{ maxWidth: "140px", maxHeight: "60px" }}
              />
            )}
            {this.state.exceptionType === 0 && (
              <p
                style={{ margin: 0, paddingLeft: 50 }}
                className={classes.header}
              >
                {" "}
                {t("exception.label")}{" "}
              </p>
            )}
            {this.state.exceptionType === 1 && (
              <p
                style={{ margin: 0, paddingLeft: 50 }}
                className={classes.header}
              >
                {" "}
                {t("check.label")}{" "}
              </p>
            )}
            {this.state.exceptionType === 1 && (
              <Button
                style={{ padding: 10, minWidth: 6 }}
                title={t("back.label")}
                color="inherit"
                onClick={(event) => this.handleBack(event, 1)}
              >
                <BackIcon />
              </Button>
            )}
            {this.state.exceptionType === 2 && (
              <p
                style={{ margin: 0, paddingLeft: 50 }}
                className={classes.header}
              >
                {" "}
                {t("ach.label")}{" "}
              </p>
            )}
            {this.state.exceptionType === 2 && (
              <Button
                style={{ padding: 10, minWidth: 6 }}
                title={t("saveBack.label")}
                color="inherit"
                onClick={(event) => this.handleBack(event, 0)}
              >
                <BackIcon />
              </Button>
            )}

            {this.state.exceptionType === 3 && (
              <p
                style={{ margin: 0, paddingLeft: 5 }}
                className={classes.header}
              >
                {" "}
                {t("addNote.label")}{" "}
              </p>
            )}
            {this.state.exceptionType === 3 && (
              <Button
                style={{ padding: 10, minWidth: 6 }}
                title={t("saveBack.label")}
                color="inherit"
                onClick={(event) => this.handleSetNewNote(event)}
              >
                <BackIcon />
              </Button>
            )}

            {this.state.exceptionType === 4 && (
              <p
                style={{ margin: 0, paddingLeft: 50 }}
                className={classes.header}
              >
                {" "}
                {t("image.label")}{" "}
              </p>
            )}
            {this.state.exceptionType === 4 && (
              <Button
                style={{ padding: 10, minWidth: 6 }}
                title={t("back.label")}
                color="inherit"
                onClick={(event) => this.handleBack(event, 2)}
              >
                <BackIcon />
              </Button>
            )}
            <Button
              style={{
                margin: 0,
                padding: 0,
                minWidth: 6,
                right: 0,
                position: "absolute",
              }}
              title={t("signOut.label")}
              color="inherit"
              onClick={this.handleLogout}
            >
              <LogoutIcon />
            </Button>
          </Toolbar>
        </AppBar>
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyOnlyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyOnlyString}
            error={false}
            onClosePopup={this.onCloseNotifyOnly}
          />
        )}
        {this.state.viewPopup && this.state.validationError.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.validationError}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.viewPopup && this.state.actionError.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.actionError}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.confirmSaveDialog && (
          <ConfirmDialog
            title={t("confirmSave.label")}
            text={t("saveAch.label")}
            onCloseConfirm={this.handleSaveAch}
          />
        )}

        {this.state.errorString.length === 0 && this.state.exceptionType === 0 && (
          <div
            style={{
              width: "100%",
              marginRight: "auto",
              marginLeft: "auto",
              padding: 20,
            }}
          >
            {!this.state.messagesShowing && (
              <div style={{ display: "block", height: 110, overflowY: "auto" }}>
                <Paper>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>{t("noMessage.label")}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
            {this.state.messagesShowing && (
              <div style={{ display: "block", height: 100, overflowY: "auto" }}>
                <Paper>
                  <Table>
                    <TableBody>
                      {messages.map((message) => {
                        return (
                          <TableRow key={message.id} style={{ height: 24 }}>
                            <TableCell
                              style={{
                                margin: 0,
                                borderBottom: "none",
                                padding: 0,
                                color: "red",
                              }}
                              className={classes.primaryText}
                            >
                              {message.text}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
            <br></br>

            <div style={{ margin: 0 }}>
              <Typography
                variant="body1"
                color="error"
                className={classes.bodyFont}
              >
                <strong> {this.state.minutesLeft} </strong>{" "}
                {t("minuteLeft.label")}
              </Typography>
            </div>
            <br></br>

            <div style={{ margin: 0 }}>
              <Paper elevation={0}>
                <Table>
                  {items.map((item) => {
                    return (
                      <TableBody>
                        <TableRow style={{ height: 0 }}>
                          <TableCell
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                              width: "90%",
                            }}
                            className={classes.primaryText}
                          >
                            <strong>
                              {t("acct.label")}: {item.account}
                            </strong>
                          </TableCell>
                        </TableRow>
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending === 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending === 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                  width: "95%",
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc}{" "}
                                  {t("checks.label")} | {item.num_has_ach_exc}{" "}
                                  {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                  width: "5%",
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending > 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending > 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc} (
                                  <font style={{ color: "red" }}>
                                    {item.num_chk_pending}
                                  </font>
                                  ) {t("checks.label")} | {item.num_has_ach_exc}{" "}
                                  (
                                  <font style={{ color: "red" }}>
                                    {item.num_ach_pending}
                                  </font>
                                  ) {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending > 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending === 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc} (
                                  <font style={{ color: "red" }}>
                                    {item.num_chk_pending}
                                  </font>
                                  ) {t("checks.label")} | {item.num_has_ach_exc}{" "}
                                  {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending === 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending > 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc}{" "}
                                  {t("checks.label")} | {item.num_has_ach_exc} (
                                  <font style={{ color: "red" }}>
                                    {item.num_ach_pending}
                                  </font>
                                  ) {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending > 0 &&
                          !item.has_ach_exc && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc} (
                                  <font style={{ color: "red" }}>
                                    {item.num_chk_pending}
                                  </font>
                                  ) {t("checks.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc > 0 &&
                          item.num_chk_pending === 0 &&
                          !item.has_ach_exc && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_chk_exc}{" "}
                                  {t("checks.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc === 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending > 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_ach_exc} (
                                  <font style={{ color: "red" }}>
                                    {item.num_ach_pending}
                                  </font>
                                  ) {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {item.has_chk_exc &&
                          item.num_has_chk_exc === 0 &&
                          item.has_ach_exc &&
                          item.num_has_ach_exc > 0 &&
                          item.num_ach_pending === 0 && (
                            <TableRow>
                              <TableCell
                                style={{
                                  margin: 0,
                                  borderBottom: "none",
                                  padding: 0,
                                }}
                                className={classes.secondaryText}
                              >
                                <strong>
                                  {t("items.label")}: {item.num_has_ach_exc}{" "}
                                  {t("achs.label")}
                                </strong>
                              </TableCell>
                              <TableCell
                                style={{
                                  borderBottom: "none",
                                  right: 0,
                                }}
                              >
                                <Button
                                  onClick={(event) =>
                                    this.handleSelectAccount(
                                      event,
                                      item.index,
                                      item
                                    )
                                  }
                                >
                                  {(!this.state.blockShowing ||
                                    (this.state.selectedAccountIndex !==
                                      item.index &&
                                      this.state.blockShowing)) && (
                                    <ArrowDownIcon />
                                  )}
                                  {this.state.selectedAccountIndex ===
                                    item.index &&
                                    this.state.blockShowing && <ArrowUpIcon />}
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        {this.state.selectedAccountIndex === item.index &&
                          this.state.blockShowing && (
                            <div>
                              <ExceptionsPage
                                history={this.props.history}
                                secureToken={this.props.reply.secureToken}
                                item={this.state.selectedItemObject}
                                onCallBack={this.handleSubpageCallback}
                                type={this.state.type}
                              >
                                {" "}
                              </ExceptionsPage>
                            </div>
                          )}
                      </TableBody>
                    );
                  })}
                </Table>
              </Paper>
            </div>
          </div>
        )}
        {this.state.errorString.length === 0 &&
          this.state.exceptionType === 1 &&
          this.state.viewCheckDetail && (
            <div
              style={{ width: "100%", marginRight: "auto", marginLeft: "auto" }}
            >
              {this.state.detailedItem.lockName !== "" &&
                this.state.detailedItem.revState === "1" && (
                  <table style={{ paddingLeft: 20 }}>
                    <tr>
                      <td style={{ color: "red" }}>
                        {" "}
                        <strong>{t("itemLock.label")} </strong>{" "}
                        {this.state.detailedItem.lockName}
                      </td>
                    </tr>
                  </table>
                )}
              <br />
              <table style={{ paddingLeft: 20 }}>
                <tr>
                  <td>
                    {" "}
                    <strong>{t("transit.label")}: </strong> {this.state.transit}{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <strong>{t("account.label")}: </strong> {this.state.account}
                  </td>
                </tr>
              </table>
              <br />
              <div style={{ paddingLeft: 20 }}>
                <img
                  src={imgUrl}
                  alt="Not Available"
                  style={{ width: "96%" }}
                  onClick={(event) => this.handleShowImg(event)}
                ></img>
              </div>
              <div style={{ overflowY: "auto", paddingLeft: 20 }}>
                <table>
                  <tr>
                    {this.state.detailedItem.issueAmountRequired && (
                      <td>
                        <strong>{t("issueAmount.label")}:</strong>{" "}
                        {this.state.detailedItem.issueAmount}&nbsp;
                      </td>
                    )}
                    {this.state.detailedItem.issuePayeeRequired && (
                      <td>
                        <strong>{t("issuePayee.label")}:</strong>{" "}
                        {this.state.detailedItem.iPayee}
                      </td>
                    )}
                  </tr>
                </table>

                {(!this.state.detailedItem.canDisposition ||
                  !this.state.currentDay) && (
                  <div>
                    <p>
                      {" "}
                      <strong>{t("checkNumber.label")}:</strong>{" "}
                      {this.state.checkNumber} &nbsp;
                      <strong>{t("amount.label")}:</strong> {this.state.amount}
                    </p>
                    <p>
                      {" "}
                      <strong>{t("payee.label")}:</strong> {this.state.payee}
                    </p>
                    <p>
                      {" "}
                      <strong>{t("comments.label")}:</strong>
                      {this.state.detailedItem.notes}
                    </p>
                  </div>
                )}
                {this.state.detailedItem.canDisposition &&
                  this.state.currentDay && (
                    <div>
                      <table style={{ width: "96%", overflowY: "auto" }}>
                        <tr>
                          <td style={{ padding: 0, margin: 0 }}>
                            <TextField
                              margin="dense"
                              id="checkNumber"
                              label={t("checkNumber.label")}
                              type="text"
                              fullWidth
                              required
                              defaultValue={this.state.checkNumber}
                              onChange={(event) =>
                                this.handleCheckNumber(event)
                              }
                              onKeyPress={(event) => {
                                return event.charCode >= 48 &&
                                  event.charCode <= 57
                                  ? true
                                  : event.preventDefault();
                              }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: 0, margin: 0 }}>
                            <TextField
                              margin="dense"
                              id="amount"
                              label={t("amount.label")}
                              type="text"
                              fullWidth
                              required
                              defaultValue={this.state.amount}
                              onChange={(event) => this.handleAmount(event)}
                              onKeyPress={(event) => {
                                return event.charCode === 46 ||
                                  (event.charCode >= 48 && event.charCode <= 57)
                                  ? true
                                  : event.preventDefault();
                              }}
                            />
                          </td>
                        </tr>
                        {(this.state.detailedItem.payeeRequired ||
                          this.state.reason.indexOf("ACH") >= 0) && (
                          <tr>
                            <td style={{ padding: 0, margin: 0 }}>
                              <Tooltip title={this.state.payee}>
                                <TextField
                                  margin="dense"
                                  id="payee"
                                  label={t("payee.label")}
                                  fullWidth
                                  required
                                  defaultValue={this.state.payee}
                                  onChange={(event) => this.handlePayee(event)}
                                />
                              </Tooltip>
                            </td>
                          </tr>
                        )}
                        {this.state.detailedItem.eccRequired && (
                          <tr>
                            <td style={{ padding: 0, margin: 0 }}>
                              <TextField
                                margin="dense"
                                id="auth_code"
                                label={t("authenticationCode.label")}
                                fullWidth
                                required
                                defaultValue={this.state.authCode}
                                onChange={(event) => this.handleAuthCode(event)}
                              />
                            </td>
                          </tr>
                        )}
                        {this.state.status === "Return" && (
                          <tr>
                            <td style={{ padding: 0, margin: 0 }}>
                              <TextField
                                margin="dense"
                                id="returnedReason"
                                label={t("returnedReason.label")}
                                fullWidth
                                defaultValue={this.state.returnedReason}
                                disabled
                              />
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td style={{ height: 50 }}></td>
                        </tr>
                      </table>
                    </div>
                  )}
              </div>
              <BottomNavigation
                className={classes.bottom}
                value={this.state.value}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    {this.state.detailedItem.canDisposition &&
                      this.state.detailedItem.revState < 5 &&
                      this.state.item.status !== "P1" &&
                      this.state.item.status !== "P2" && (
                        <td style={{ width: "50%", margin: 0, padding: 0 }}>
                          <div>
                            <StyledHtmlSelect
                              disabled={
                                !this.state.detailedItem.canDisposition ||
                                !this.state.currentDay
                              }
                              onChange={(event) => this.handleReturnCode(event)}
                            >
                              {this.state.returnCodes.map((n) => {
                                return (
                                  <option value={n.id}>
                                    {n.id === "000"
                                      ? t("return.label")
                                      : n.description}
                                  </option>
                                );
                              })}
                            </StyledHtmlSelect>
                          </div>
                        </td>
                      )}
                    <td style={{ width: "30%", margin: 0, padding: 0 }}>
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        this.state.item.status !== "P1" &&
                        this.state.item.status !== "P2" && (
                          <Button
                            onClick={(event) => this.onPay(event)}
                            color="primary"
                          >
                            <PayIcon />
                            &nbsp;{t("pay.label")}
                          </Button>
                        )}
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        this.state.item.status === "P1" && (
                          <Button
                            onClick={(event) => this.onPay(event)}
                            color="primary"
                          >
                            <PayIcon />
                            &nbsp;{t("approvePay.button")}
                          </Button>
                        )}
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        this.state.item.status === "P2" && (
                          <Button
                            onClick={(event) => this.onPay(event)}
                            color="primary"
                          >
                            <PayIcon />
                            &nbsp;{t("approveReturn.button")}
                          </Button>
                        )}
                      {/*{this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        (this.state.item.status !== "P1") &&
                        (this.state.item.status !== "P2") && (
                          <Button
                            onClick={(event) => this.onReturn(event)}
                            color="primary"
                          >
                            <ReturnIcon />
                            &nbsp;{t("return.label")}
                          </Button>
                        )}*/}
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        this.state.item.status === "P1" && (
                          <Button
                            onClick={(event) => this.onReturn(event)}
                            color="primary"
                          >
                            <ReturnIcon />
                            &nbsp;{t("denyPay.button")}
                          </Button>
                        )}
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        this.state.item.status === "P2" && (
                          <Button
                            onClick={(event) => this.onReturn(event)}
                            color="primary"
                          >
                            <ReturnIcon />
                            &nbsp;{t("denyReturn.button")}
                          </Button>
                        )}
                    </td>
                    <td
                      style={{ width: "20%", right: 0, margin: 0, padding: 0 }}
                    >
                      {this.state.detailedItem.canDisposition &&
                        this.state.detailedItem.revState < 5 &&
                        !(this.state.item.status === "P1") &&
                        !(this.state.item.status === "P2") && (
                          <Button
                            onClick={(event) => this.onRevalidate(event)}
                            color="primary"
                          >
                            <RevalidateIcon />
                            &nbsp;{t("revalidate.button")}
                          </Button>
                        )}
                    </td>
                  </tr>
                </table>
              </BottomNavigation>
            </div>
          )}
        {this.state.errorString.length === 0 && this.state.exceptionType === 2 && (
          <div
            style={{
              width: "100%",
              marginRight: "auto",
              marginLeft: "auto",
              paddingLeft: 20,
            }}
          >
            <br />
            <Typography className={classes.bodyFont}>
              Company Name: {this.state.compName}
            </Typography>
            <br />
            <Table>
              {this.state.achItemDetails.map((n) => {
                return (
                  <TableBody>
                    <TableRow id={"idach" + n.index}>
                      <TableCell
                        style={{
                          borderBottom: "none",
                          width: "30%",
                          margin: 0,
                          padding: 0,
                        }}
                        className={classes.primaryText}
                      >
                        {n.amount}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "none",
                          width: "30%",
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        <Chip
                          label={n.status}
                          style={{ backgroundColor: "#2196F3" }}
                        ></Chip>
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "none",
                          width: "25%",
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        <Button
                          onClick={(event) =>
                            this.handleSelectAch(event, n.index, n)
                          }
                        >
                          <MoreIcon />
                        </Button>

                        {this.state.selectedAchIndex === n.index &&
                          this.state.menuShowing && (
                            <div className={classes.dropdown}>
                              <div className={classes.dropdownContent}>
                                <ClickAwayListener
                                  onClickAway={this.handleClose}
                                >
                                  <MenuList>
                                    <MenuItem
                                      onClick={(event) =>
                                        this.handleChangeStatus(
                                          event,
                                          n.index,
                                          n,
                                          "Return"
                                        )
                                      }
                                    >
                                      {t("returnMenu.label")}
                                    </MenuItem>
                                    <MenuItem
                                      onClick={(event) =>
                                        this.handleChangeStatus(
                                          event,
                                          n.index,
                                          n,
                                          "Pay"
                                        )
                                      }
                                    >
                                      {t("payMenu.label")}
                                    </MenuItem>
                                    <div className={classes.line}></div>
                                    <MenuItem
                                      onClick={(event) =>
                                        this.handleSelectAddNote(
                                          event,
                                          n.index,
                                          n
                                        )
                                      }
                                    >
                                      {t("addNote.label")}
                                    </MenuItem>
                                  </MenuList>
                                </ClickAwayListener>
                              </div>
                            </div>
                          )}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "none",
                          right: 0,
                          position: "absolute",
                          width: "15%",
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        <Button
                          onClick={(event) =>
                            this.handleSelectAchItem(event, n.index, n)
                          }
                        >
                          {(!this.state.detailShowing ||
                            (this.state.selectedAchItemIndex !== n.index &&
                              this.state.detailShowing)) && <ArrowDownIcon />}
                          {this.state.selectedAchItemIndex === n.index &&
                            this.state.detailShowing && <ArrowUpIcon />}
                        </Button>
                      </TableCell>
                    </TableRow>

                    {this.state.selectedAchItemIndex === n.index &&
                      this.state.detailShowing && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            style={{
                              borderBottom: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            <Table style={{ width: "100%" }}>
                              <TableBody>
                                <TableRow style={{ height: 0 }}>
                                  <TableCell
                                    className={classes.secondaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {t("trace.label")}{" "}
                                  </TableCell>
                                  &nbsp;&nbsp;
                                  <TableCell
                                    className={classes.primaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {n.trace}
                                  </TableCell>
                                </TableRow>
                                <TableRow style={{ height: 0 }}>
                                  <TableCell
                                    className={classes.secondaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {t("creditIndex.label")}
                                  </TableCell>
                                  &nbsp;&nbsp;
                                  <TableCell
                                    className={classes.primaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {n.isDebit}
                                  </TableCell>
                                </TableRow>
                                <TableRow style={{ height: 0 }}>
                                  <TableCell
                                    className={classes.secondaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {t("serialNumber.label")}
                                  </TableCell>
                                  &nbsp;&nbsp;
                                  <TableCell
                                    className={classes.primaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {n.tranSerialNo}
                                  </TableCell>
                                </TableRow>
                                <TableRow style={{ height: 0 }}>
                                  <TableCell
                                    className={classes.secondaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {t("details.label")}
                                  </TableCell>
                                  &nbsp;&nbsp;
                                  <TableCell
                                    className={classes.primaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {n.payRelatedInfo}
                                  </TableCell>
                                </TableRow>
                                <TableRow style={{ height: 0 }}>
                                  <TableCell
                                    className={classes.secondaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {t("notes.label")}
                                  </TableCell>
                                  &nbsp;&nbsp;
                                  <TableCell
                                    className={classes.primaryText}
                                    style={{
                                      margin: 0,
                                      borderBottom: "none",
                                      padding: 0,
                                    }}
                                  >
                                    {n.note}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                );
              })}
              <TableRow></TableRow>
            </Table>
          </div>
        )}
        {this.state.errorString.length === 0 && this.state.exceptionType === 3 && (
          <div>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{ borderBottom: "none", width: "20%" }}
                    className={classes.primaryText}
                  >
                    {this.state.selectedNoteObject.amount}
                  </TableCell>
                  <TableCell
                    style={{
                      borderBottom: "none",
                      right: 0,
                      position: "absolute",
                    }}
                  >
                    <Chip
                      label={this.state.selectedNoteObject.status}
                      style={{ backgroundColor: "#2196F3" }}
                    ></Chip>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2} style={{ borderBottom: "none" }}>
                    <Table style={{ width: "100%" }}>
                      <TableBody>
                        <TableRow style={{ height: 0 }}>
                          <TableCell
                            className={classes.secondaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {t("trace.label")}
                          </TableCell>
                          &nbsp;&nbsp;
                          <TableCell
                            className={classes.primaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {this.state.selectedNoteObject.trace}
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ height: 0 }}>
                          <TableCell
                            className={classes.secondaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {t("creditIndex.label")}
                          </TableCell>
                          &nbsp;&nbsp;
                          <TableCell
                            className={classes.primaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {this.state.selectedNoteObject.isDebit}
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ height: 0 }}>
                          <TableCell
                            className={classes.secondaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {t("serialNumber.label")}
                          </TableCell>
                          &nbsp;&nbsp;
                          <TableCell
                            className={classes.primaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {this.state.selectedNoteObject.tranSerialNo}
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ height: 0 }}>
                          <TableCell
                            className={classes.secondaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {t("details.label")}
                          </TableCell>
                          &nbsp;&nbsp;
                          <TableCell
                            className={classes.primaryText}
                            style={{
                              margin: 0,
                              borderBottom: "none",
                              padding: 0,
                            }}
                          >
                            {this.state.selectedNoteObject.payRelatedInfo}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{ borderBottom: "none", margin: 0, padding: 0 }}
                  >
                    <Divider />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{ borderBottom: "none", margin: 0 }}
                  >
                    <TextField
                      margin="dense"
                      id="newNote"
                      label={t("notes.label")}
                      fullWidth
                      defaultValue={this.state.selectedNoteObject.note}
                      onChange={(event) =>
                        this.handleNewNote(
                          event,
                          this.state.selectedNoteObject.note,
                          this.state.selectedNoteObject.status
                        )
                      }
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        )}
        {this.state.exceptionType === 4 && (
          <div
            style={{
              paddingLeft: 20,
              right: 0,
              overflowX: "auto",
              overflowY: "auto",
            }}
          >
            <img
              src={imgUrl}
              alt="Not Available"
              style={{ width: "800", height: "400" }}
            ></img>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(InfoPage));
